import {
  configureStore,
  type EnhancedStore,
  type StoreEnhancer,
  type ThunkDispatch,
  type Tuple,
  type UnknownAction,
} from '@reduxjs/toolkit';

import selvtest, { type SelvtestState } from './selvtestSlice';

export function setupStore(preloadedState?: RootState): EnhancedStore<
  SelvtestState,
  UnknownAction,
  Tuple<
    [
      StoreEnhancer<{
        dispatch: ThunkDispatch<SelvtestState, undefined, UnknownAction>;
      }>,
      StoreEnhancer,
    ]
  >
> {
  return configureStore({
    reducer: selvtest,
    preloadedState,
    devTools: import.meta.env.DEV,
  });
}
export type RootState = ReturnType<typeof selvtest>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
